import { AuthenticationClientOptions } from '@/iam/types'
import { Plugin } from 'vue'
import { SentryConfig } from '@ankor-io/sentry-conflux/src/types'

/**
 * The config type definition
 */

export declare type Config = {
  /**
   * The Stowage http endpoint url
   */
  STOWAGE_URL: string

  /**
   * The Wave base url
   */
  WAVE_URL: string

  /**
   * Kinde client related configurations
   */
  AUTHENTICATION_CLIENT_OPTIONS: AuthenticationClientOptions

  /**
   * Algolia config setting relevant to the front end. Important: do not include any api keys here.
   */
  ALGOLIA: {
    /**
     * The algolia app id
     */
    app_id: string
    /**
     * The algolia itinerary index
     */
    itinerary_index: string
  }

  /**
   * GTM config required to initialize GTM plugin
   */
  GTM: {
    /**
     * ID for the GTM Container
     */
    id: string
    /**
     * The preview id of the container
     */
    gtm_preview: string
    /**
     * The auth for GTM container
     */
    gtm_auth: string
  }
  /**
   * Config for mixpanel
   */
  MIXPANEL: {
    /**
     * Mixpanel token
     */
    token: string
  }
  /**
   * GROWTHBOOK config for creating a growthbook instance
   * Use the SDK connection since the endpoint has now been deprecated
   */
  GROWTHBOOK: {
    /**
     * Client key used for registration of SDK connection
     */
    clientKey: string
    /**
     * Whether to enable development mode
     */
    enableDevMode: boolean
  }
  /**
   * Sentry tracing settings
   */
  SENTRY: SentryConfig
}

// intersect our main type with a Vue app plugin for using it in the app.
export type AppConfig = Config & Plugin
export const ConfigKey: string = 'config'
